import React, {useEffect, useState} from "react";
import { Column } from "@amzn/meridian";
import { useAppDispatch } from "src/store/store";
import BarcodeFrame from "../../barcodeScanner/BarcodeFrame";
import { setShownHumanText } from "src/store/workflowSlice";
import StepTransitionSheet from "./StepTransitionSheet";
import ContainerCountOverlay from "./ContainerCountOverlay";
import "./detectObjectStep.scss";

interface ReadBarcodeStepProps {
  humanText: string;
  onComplete: () => void;
}

const ReadBarcodeStep: React.FC<ReadBarcodeStepProps> = ({
  humanText,
  onComplete,
}) => {
  const dispatch = useAppDispatch();
  const [stepComplete, setStepComplete] = useState(false);

  useEffect(() => {
      dispatch(setShownHumanText(humanText));
  }, []);

  return (
    <Column height="100vh" className="detect-object-step pwa-fullscreen-viewport">
      <ContainerCountOverlay />
      <BarcodeFrame onBarcodeConfirmed={() => setStepComplete(true)} />
      { stepComplete && <StepTransitionSheet
        headerMessage="Barcode Scanned."
        message="Get ready to focus container."
        onClose={onComplete}
      />}
    </Column>
  );
};

export default ReadBarcodeStep;
